<script>
    // header with graphical element and website title above each page.
    // situated above the main container
</script>
<header class="not-print">
    <div class="top">
        <h1>Horoscoopberekening</h1>
    </div>
</header>

<style>
    .top {
        position: relative; 
        margin: 0 auto;
    max-width: 650px;
    background-color: whitesmoke;
   padding-top: 5px;
    padding-bottom: 10px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
        margin-bottom: 0;

        
    }

    h1 {
        text-align: center;
        font-size: 1.5rem;
        font-weight: 400;
        margin-bottom: 0;
        margin-top: 0;

    }

    @media print {
        .not-print {
            display: none;
        }
    }   
</style>